var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEurs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_736_3870)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4778 14.9052C15.0746 14.9052 14.9066 15.1404 14.6042 15.3588C13.9322 15.8796 13.3274 16.098 12.5378 16.098C11.1098 16.098 10.001 15.3252 9.4634 14.0316H12.3698C12.7562 14.0316 13.0754 13.7292 13.0754 13.3428C13.0754 12.9396 12.7562 12.6372 12.3698 12.6372H9.1106C9.0938 12.4356 9.077 12.2172 9.077 11.9988C9.077 11.7972 9.0938 11.6124 9.1106 11.4276H13.0922C13.4954 11.4276 13.7978 11.1252 13.7978 10.722C13.7978 10.3356 13.4954 10.0332 13.0922 10.0332H9.4298C9.9674 8.70602 11.0762 7.89962 12.5378 7.89962C13.3442 7.89962 13.9658 8.11802 14.6042 8.63882C14.9066 8.85722 15.0746 9.09242 15.4778 9.09242C15.8978 9.09242 16.2338 8.72282 16.2338 8.28602C16.2338 8.05082 16.1498 7.84922 15.9146 7.61402C15.0746 6.75722 13.8482 6.27002 12.4706 6.27002C10.0346 6.27002 8.1698 7.74842 7.4978 10.0332H6.4226C6.0362 10.0332 5.717 10.3356 5.717 10.722C5.717 11.1252 6.0362 11.4276 6.4226 11.4276H7.2458C7.229 11.6124 7.229 11.7972 7.229 11.9988C7.229 12.2172 7.2458 12.4356 7.2626 12.6372H6.4058C6.0026 12.6372 5.7002 12.9396 5.7002 13.3428C5.7002 13.7292 6.0026 14.0316 6.4058 14.0316H7.5314C8.2202 16.266 10.085 17.7276 12.4706 17.7276C13.8482 17.7276 15.0746 17.2404 15.9146 16.3836C16.1498 16.1484 16.2338 15.9468 16.2338 15.7116C16.2338 15.2748 15.8978 14.9052 15.4778 14.9052Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_736_3870",
    x1: 20.4782,
    y1: 3.52181,
    x2: 3.51421,
    y2: 20.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B742EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392617,
    stopColor: "#144BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15BCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurs);
export default __webpack_public_path__ + "static/media/eurs.42140bf520b4735bfd904976e6772e00.svg";
export { ForwardRef as ReactComponent };